import { setWorkerAppRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import { setRebrandingEnabled } from "./appV2/redesign/Rebranding/workerAppRebranding";

const REBRANDING_LOCAL_STORAGE_KEY = "worker-app-rebranding-enabled";

const isEnabled = localStorage.getItem(REBRANDING_LOCAL_STORAGE_KEY) === "true";

if (isEnabled) {
  setWorkerAppRebrandingEnabled(true);
  setRebrandingEnabled(true);
}

export { REBRANDING_LOCAL_STORAGE_KEY };
